import { render, staticRenderFns } from "./Parcelamento.vue?vue&type=template&id=31d974ea"
import script from "./Parcelamento.vue?vue&type=script&lang=js"
export * from "./Parcelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports